// =============================================================
// IMPORTS
// =============================================================

// =============================================================
// MODULES
// - Lazy loaded modules which are imported when needed
// =============================================================

if (document.querySelectorAll("#asjc-url").length > 0) {
  import("./modules/asCaritasJobs.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll("#acl-list").length > 0) {
  import("./modules/asCaritasLocations.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".banner").length > 0) {
  import("./modules/banner.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".main-nav").length > 0) {
  import("./modules/flyout.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".lightbox").length > 0) {
  import("./modules/lightbox.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".modal")) {
  import("./modules/modal.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll("section .panel").length > 0) {
  import("./modules/panels.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll('[data-js="content-video-1"]').length > 0) {
  import("./modules/plyr-modal.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".video-embed-item").length > 0) {
  import("./modules/plyr.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".ctype-ce_salary_tables").length > 0) {
  import("./modules/salaryTables.module.js").then((module) => {
    module.init();
  });
}

if (
  document.querySelector(".btn--share-facebook") ||
  document.querySelector(".btn--share-twitter") ||
  document.querySelector(".btn--share-linkedin") ||
  document.querySelector(".btn--share-xing") ||
  document.querySelector(".btn--share-telegram") ||
  document.querySelector(".btn--share-whatsapp") ||
  document.querySelector(".btn--share-mail")
) {
  import("./modules/sharing.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".content-slider").length > 0) {
  import("./modules/slider.module.js").then((module) => {
    module.init();
  });
}

if (document.querySelectorAll(".ctype-ce_job_search .form").length > 0) {
  import("./modules/ceJobSearch.module.js").then((module) => {
    module.init();
  });
}

// =============================================================
// OTHER
// =============================================================
let jobListIndex = location.pathname.indexOf("/jobs");
let jobOffersIndex = location.pathname.indexOf("/stellenangebote");
let jobDevIndex = location.pathname.indexOf("/as-jobs");
let jobOfferIndex = location.pathname.indexOf("/jobs/angebot");
let devIndex = location.pathname.indexOf("/bewerben/stellenangebote/detail");

let socialLinks = document.querySelector(".social-links");
let shareLinks = document.querySelector(".share-links");

if (jobListIndex === -1 && jobOffersIndex === -1 && jobDevIndex === -1) {
  localStorage.removeItem("prevFlag");
}

if (jobOfferIndex > -1 || devIndex > -1) {
  socialLinks ? socialLinks.classList.add("hide") : null;
  shareLinks ? shareLinks.classList.remove("hide") : null;
} else {
  socialLinks ? socialLinks.classList.remove("hide") : null;
}

// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
// const whenComplete = () => {
//   if (document.readyState === "complete") {
//     // -------------------------------------------------------------
//     // for example: general "on" listeners
//     // -------------------------------------------------------------
//     window.addEventListener("resize", function (e) {
//       console.log("resize");
//     });
//     // -------------------------------------------------------------
//   } else {
//     setTimeout(function () {
//       whenComplete();
//     }, 400);
//   }
// };
// whenComplete();

// =============================================================
// STYLES COMPLETE
// Removes styles_essential when general styles are loaded
// =============================================================
// let styleAttempts = 0;
// const stylesComplete = () => {
//   if (styleAttempts > 30) return;
//   styleAttempts += 1;
//   if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
//     document.querySelector("#sess").remove();
//   } else {
//     setTimeout(function () {
//       stylesComplete();
//     }, 300);
//   }
// };
// stylesComplete();
